class ShippingInformation extends HTMLElement {
  constructor() {
    super();

    this.informationBlocks = this.querySelectorAll(".js-shipping-information");
    this.select = this.querySelector("select");
    if (this.select && this.informationBlocks.length) {
      this.select.addEventListener("input", () => {
        this.informationBlocks.forEach((block) => {
          if (block.getAttribute("data-country") == this.select.value) {
            block.classList.remove("hidden");
          } else {
            block.classList.add("hidden");
          }
        });
      });
    }
  }
}

customElements.define("shipping-information", ShippingInformation);
